import { FilterIds } from '@customer-apps/shared/enums';
import { EnumDictionary } from '../types';

export const activeFilterDictionary: Partial<EnumDictionary<FilterIds, string>> = {
    [FilterIds.DateFrom]: 'PROJECTS.ACTIVE_FILTERS.DATE_FROM',
    [FilterIds.DateTo]: 'PROJECTS.ACTIVE_FILTERS.DATE_TO'
};
